/* FindTag GA4 storefront measurement. Remove when the Shopify Google & YouTube channel owns this same stream. */
(() => {
  "use strict";

  const measurementId = "G-YY0SX79LP7";
  const shopify = window.Shopify;
  if (window.__findtagGA4Initialized || !shopify || typeof shopify.loadFeatures !== "function") return;
  // If Shopify's native Google channel owns the stream, do not alter its consent state.
  if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`)) return;
  window.__findtagGA4Initialized = true;

  // Basic consent mode: do not load the Google tag or send a page view until
  // Shopify permits analytics processing for this visitor and region.
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied"
  });

  shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
    if (error || !shopify.customerPrivacy) return;
    const privacy = shopify.customerPrivacy;
    let tagLoaded = false;

    function syncAnalyticsPermission() {
      let permitted = false;
      let marketing = false;
      let dataSharing = false;
      try {
        permitted = privacy.analyticsProcessingAllowed() === true;
        marketing = privacy.marketingAllowed() === true;
        dataSharing = privacy.saleOfDataAllowed() === true;
      } catch (_error) {
        return;
      }

      const personalisedAds = marketing && dataSharing;
      gtag("consent", "update", {
        analytics_storage: permitted ? "granted" : "denied",
        ad_storage: marketing ? "granted" : "denied",
        ad_user_data: personalisedAds ? "granted" : "denied",
        ad_personalization: personalisedAds ? "granted" : "denied"
      });
      if (!permitted || tagLoaded) return;

      tagLoaded = true;
      gtag("js", new Date());
      gtag("config", measurementId);
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);
    }

    syncAnalyticsPermission();
    document.addEventListener("visitorConsentCollected", syncAnalyticsPermission);
  });
})();
